module.exports = __webpack_public_path__ + "static/media/remote.4104f72c.png";